var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 5.5,
  fill: "#FCFCFC",
  stroke: "var(--color)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--color)",
  d: "M5.524 2.32a.5.5 0 0 1 .951 0l.567 1.745a.5.5 0 0 0 .476.346h1.834a.5.5 0 0 1 .294.904L8.162 6.394a.5.5 0 0 0-.182.559l.567 1.744a.5.5 0 0 1-.77.56l-1.482-1.08a.5.5 0 0 0-.588 0L4.222 9.256a.5.5 0 0 1-.77-.559l.567-1.744a.5.5 0 0 0-.181-.56L2.354 5.316a.5.5 0 0 1 .293-.904h1.835a.5.5 0 0 0 .475-.346l.567-1.744z"
})));
export default SvgStar;